import indigo from '@material-ui/core/colors/indigo';
import pink from '@material-ui/core/colors/pink';

export default {
  palette: {
    primary: {
      light: '#302f2f',
      main: '#302f2f',
      dark: '#302f2f',
      contrastText: '#fff'
    },
    secondary: {
      light: '#5E60CE',
      main: '#5E60CE',
      dark: '#5E60CE',
      contrastText: '#fff'
    }
  },
  status: {
    danger: 'orange',
  },

  typography: {
    button: {
      fontWeight: 400,
      textAlign: 'capitalize'
    },
    fontFamily:'exoFont'
  },
};
